// custom safegaurd script start
function customSafegaurd(){
  
    // console.log('customSafegaurd');

  // custom safegaurd script start
    // setTimeout(function(){
      // // console.log('in snippet drawer');
      // return false;
      let safeguardPriceCheckbox = document.querySelector('.checkbox-content input.check-box').getAttribute('data-variant-price');
      // console.log('safeguardPriceCheckbox', safeguardPriceCheckbox);
      
      let checkBox = document.querySelector(".check-box");
      let safeguardBox = document.querySelector(".shipping-guard:not(.free-gift-item)");
      let cross = document.querySelector(".guard-cross");
    
      async function checkSafeguardStatus(checkBox){
    
        let cartTotalPrice;
        let cartOriginalTotalPrice;
        
        await fetch(window.Shopify.routes.root + 'cart.js')
                  .then(response => response.json())
                  .then(data => {               
                    // console.log('Cart Response', data);
                    cartTotalPrice = data.total_price;
                    cartOriginalTotalPrice = data.original_total_price;                
                    data.items.forEach(function(itemEle){                                    
                      let itemTitle = itemEle.title;
                      if(itemTitle.includes('Safeguard - Shipping Guarantee')){
                        cartTotalPrice = cartTotalPrice - parseFloat(safeguardPriceCheckbox);
                        cartOriginalTotalPrice = cartOriginalTotalPrice - parseFloat(safeguardPriceCheckbox);
                      }
                    });
                    // return cartTotalPrice;
                  });
        // console.log('cartTotalPrice', cartTotalPrice);
        // console.log('cartOriginalTotalPrice', cartOriginalTotalPrice);
    
        
        if(checkBox.checked == true){
            if(safeguardBox){
              safeguardBox.style.display = "flex"; 
            }
          
              //update price
              let updatedPrice = cartTotalPrice + parseFloat(safeguardPriceCheckbox);
              updatedPrice = updatedPrice/100;
              updatedPrice = parseFloat(updatedPrice);
              updatedPrice = updatedPrice.toFixed(2);
              updatedPrice = updatedPrice.toLocaleString("en-US");
              // console.log('updatedPrice', updatedPrice);
    
              
          
              setTimeout(function(){
              
                let subTotalDiv = document.querySelector("#CartDrawer #mainpricesale span.totals__total-value");
                if(subTotalDiv){
                  // subTotalDiv.textContent = `${shop_symbol}${updatedPrice}`;
                  subTotalDiv.innerHTML = `<span class="money">${shop_symbol}${updatedPrice}</span>`;
                  // console.log('subTotalDiv', subTotalDiv.textContent);
                }
                
                let itemsTotalCompareDiv = document.querySelector("#CartDrawer #mainpricesale s.price-item.price-item--regular");
                // console.log('itemsTotalCompareDiv', itemsTotalCompareDiv);
                if(itemsTotalCompareDiv){
                  let itemsTotalComparePrice = itemsTotalCompareDiv.getAttribute('data-items-total-compare-price');
                  // console.log('itemsTotalComparePrice', itemsTotalComparePrice);
                  
                  // console.log('safeguardPriceCheckbox', safeguardPriceCheckbox);
                  let comparePriceNew = parseFloat(itemsTotalComparePrice) + parseFloat(safeguardPriceCheckbox);           
                  comparePriceNew = comparePriceNew/100;
                  comparePriceNew = parseFloat(comparePriceNew);
                  comparePriceNew = comparePriceNew.toFixed(2);
                  comparePriceNew = comparePriceNew.toLocaleString("en-US");
                  // console.log('comparePriceNew ', comparePriceNew);
                  
                  itemsTotalCompareDiv.innerHTML = `<span class="money">${shop_symbol}${comparePriceNew}</span>`;
                  // console.log('itemsTotalCompareDiv', itemsTotalCompareDiv);
                }
  
                // let itemsTotalSavingsDiv = document.querySelector("#CartDrawer #mainpricesale .price-totaldiscount .pricesavings");
                // // console.log('itemsTotalSavingsDiv', itemsTotalSavingsDiv);
                // if(itemsTotalSavingsDiv){
                //   let itemsTotalSavingsPrice = itemsTotalSavingsDiv.getAttribute('data-total-savings');                
                // //   console.log('safeguardPriceCheckbox', safeguardPriceCheckbox);
                //   let savingsPriceNew = parseFloat(itemsTotalSavingsPrice) + parseFloat(safeguardPriceCheckbox);
                //   savingsPriceNew = savingsPriceNew/100;
                //   savingsPriceNew = parseFloat(savingsPriceNew);
                //   savingsPriceNew = savingsPriceNew.toFixed(2);
                //   savingsPriceNew = savingsPriceNew.toLocaleString("en-US");
                // //   console.log('savingsPriceNew ', savingsPriceNew);
                  
                //   itemsTotalSavingsDiv.innerHTML = `Save <span class="money">${shop_symbol}${savingsPriceNew}</span>`;
                // //   console.log('itemsTotalSavingsDiv', itemsTotalSavingsDiv);
                // }
                
              }, 1000);
          
        }else{
        
          if(safeguardBox){
            safeguardBox.style.display = "none"; 
          }
        
            //update price
            let updatedPrice = cartTotalPrice;
            updatedPrice = updatedPrice/100;
            updatedPrice = parseFloat(updatedPrice);
            // console.log('updatedPrice in else', updatedPrice);
            updatedPrice = updatedPrice.toFixed(2);
            updatedPrice = updatedPrice.toLocaleString("en-US");
        
        
            setTimeout(function(){
              
              let subTotalDiv = document.querySelector("#CartDrawer #mainpricesale span.totals__total-value");
              if(subTotalDiv){
                // subTotalDiv.textContent = `${shop_symbol}${updatedPrice}`;
                subTotalDiv.innerHTML = `<span class="money">${shop_symbol}${updatedPrice}</span>`;
                // console.log('subTotalDiv', subTotalDiv.textContent);
              }
              
              let itemsTotalCompareDiv = document.querySelector("#CartDrawer #mainpricesale s.price-item.price-item--regular");
              // console.log('itemsTotalCompareDiv', itemsTotalCompareDiv);
              if(itemsTotalCompareDiv){
                let itemsTotalComparePrice = itemsTotalCompareDiv.getAttribute('data-items-total-compare-price');
                // console.log('itemsTotalComparePrice', itemsTotalComparePrice);

                // console.log('safeguardPriceCheckbox', safeguardPriceCheckbox);
                let comparePriceNew = parseFloat(itemsTotalComparePrice); // - parseFloat(safeguardPriceCheckbox);           
                comparePriceNew = comparePriceNew/100;
                comparePriceNew = parseFloat(comparePriceNew);
                comparePriceNew = comparePriceNew.toFixed(2);
                comparePriceNew = comparePriceNew.toLocaleString("en-US");
                // console.log('comparePriceNew else', comparePriceNew);
                
                itemsTotalCompareDiv.innerHTML = `<span class="money">${shop_symbol}${comparePriceNew}</span>`;
                // console.log('itemsTotalCompareDiv', itemsTotalCompareDiv);
              }

              // let itemsTotalSavingsDiv = document.querySelector("#CartDrawer #mainpricesale .price-totaldiscount .pricesavings");
              // // console.log('itemsTotalSavingsDiv', itemsTotalSavingsDiv);
              // if(itemsTotalSavingsDiv){
              //   let itemsTotalSavingsPrice = itemsTotalSavingsDiv.getAttribute('data-total-savings');                
              // //   console.log('safeguardPriceCheckbox ', safeguardPriceCheckbox);
              //   let savingsPriceNew = parseFloat(itemsTotalSavingsPrice); // - parseFloat(safeguardPriceCheckbox);
              //   savingsPriceNew = savingsPriceNew/100;
              //   savingsPriceNew = parseFloat(savingsPriceNew);
              //   savingsPriceNew = savingsPriceNew.toFixed(2);
              //   savingsPriceNew = savingsPriceNew.toLocaleString("en-US");
              // //   console.log('savingsPriceNew else', savingsPriceNew);
                
              //   itemsTotalSavingsDiv.innerHTML = `Save <span class="money">${shop_symbol}${savingsPriceNew}</span>`;
              // //   console.log('itemsTotalSavingsDiv', itemsTotalSavingsDiv);
              // }
              
            }, 1000);
              
          }
      }
    
      //toggle safeguard
      if(checkBox){
        checkBox.addEventListener('click', function(){      
          checkSafeguardStatus(checkBox);
        });
      }
    
      //onload check if safeguard checked then update price  
      if(!safeguardInCart){
        // console.log('if(!safeguardInCart)')
        checkSafeguardStatus(checkBox);
      }
    
      //remove safeguard
      if(cross){
        cross.addEventListener('click', async function(){
          
          let cartContainsOnlySafegaurd = false;
          let checkSafeguardOnlyInCart = await fetch(window.Shopify.routes.root + 'cart.js')
                                  .then(response => response.json())
                                  .then(data => {               
                                    // //console.log('Cart Response cross', data);
                                    let cartItemsCount = data.item_count;
                                    data.items.forEach(function(itemEle){                                    
                                      let itemTitle = itemEle.title;
                                      if(itemTitle.includes('Safeguard - Shipping Guarantee') && cartItemsCount == 1 ){
                                        cartContainsOnlySafegaurd = true;
                                      }
                                    })
                                    return cartContainsOnlySafegaurd;
                                  });
          // console.log('checkSafeguardOnlyInCart', checkSafeguardOnlyInCart);
          
          if(checkSafeguardOnlyInCart){
            // console.log('in if')
            fetch(window.Shopify.routes.root + 'cart/clear.js')
                                  .then(response => response.json())
                                  .then(data => {               
                                    // console.log('Cart Clear Res', data);
                                    location.reload();
                                  });
          }else{          
            if(checkBox.checked){
              checkBox.click();
            }
          }
          
        });
      }
    
      
      //question mark hover functionality
      let questionMarkIcon = document.querySelector('.question-mark');
      if(questionMarkIcon){
        questionMarkIcon.addEventListener('mouseover', function(){
          let questionBox = document.querySelector('.question-hover');
          questionBox.style.display = 'block';
        });
        questionMarkIcon.addEventListener('mouseout', function(){
          let questionBox = document.querySelector('.question-hover');
          questionBox.style.display = 'none';
        });
      }
    
  //custom checkout button functionality
    let checkoutBtn = document.querySelector('#CartDrawer-Checkout');
    if(checkoutBtn){
      //remove submit attr
      checkoutBtn.setAttribute('type', 'button');
  
      //add click event and our custom functionality
      checkoutBtn.addEventListener('click', function(){
        
        let safeguardCheckbox = document.querySelector('.checkbox-content input.check-box');
        let safeguardId = safeguardCheckbox.getAttribute('data-variant-id');
        // console.log('safeguardId', safeguardId);
        let safeguardPrice = safeguardCheckbox.getAttribute('data-variant-price');
        // console.log('safeguardPrice', safeguardPrice);

        //free Stickers
        let freeStickersID = null;
        let freeStickersVariantID = document.querySelector('.free-stickers-pack').getAttribute('data-free-stickers-pack');
        if(freeStickersVariantID){
          freeStickersID = freeStickersVariantID;
        }
        console.log('freeStickersID', freeStickersID);

        //free Gift
        let freeGiftItem = document.querySelector('.free-gift-item');
        console.log('freeGiftItem', freeGiftItem)
        let freeGiftID = null;
        if(freeGiftItem){
          freeGiftID = freeGiftItem.getAttribute('data-free-gift-id');
        }
        console.log('freeGiftID', freeGiftID);
        
        if(checkBox.checked == true){
          fetch('/cart.js')
          .then(res => res.json())
          .then(data => {
            // console.log('cart data: ', data);
  
            let cartItems = data.items;
            let permalinkString = '/cart/';
            
            let addSafeguard = true;
            let addFreeStickers = true;
            let addFreeGift = true;
            
            let directCheckout = false;
            let SS_permalink_if_no_free_gift_in_cart = ``;
            
            cartItems.forEach(function(itemEle){
              let prod_title = itemEle.title;
              let prod_variant_id = itemEle.id;
              let prod_qty = itemEle.quantity;
              
              if(prod_title.includes('Safeguard')){
                addSafeguard = false;
                console.log('addSafeguard exist', addSafeguard);
                directCheckout = true;
                SS_permalink_if_no_free_gift_in_cart = `${prod_variant_id}:${prod_qty},`;
                
              }else if( prod_variant_id == freeStickersID){//for freestickers
                addFreeStickers = false;
                console.log('addFreeStickers exist', addFreeStickers);
                permalinkString += `${prod_variant_id}:${prod_qty},`;   
                
              }else if( prod_variant_id == freeGiftID){//for freegift
                addFreeGift = false;
                console.log('addFreeGift exist', addFreeGift);
                permalinkString += `${prod_variant_id}:${prod_qty},`;   
                
              }else{  
                
                permalinkString += `${prod_variant_id}:${prod_qty},`;
              }
              
            });
            
            if(addSafeguard){            
              console.log('addSafeguard exist', addSafeguard);
              permalinkString += `${safeguardId}:1,`;
            }

            if(addFreeStickers && freeStickersID != null){            
              console.log('freeStickersID exist', freeStickersID);
              permalinkString += `${freeStickersID}:1,`;
            }

            if(addFreeGift && freeGiftID != null){            
              console.log('freeGiftID exist', freeGiftID);
              permalinkString += `${freeGiftID}:1,`;
            }
            
            if(directCheckout == false){
              let finalURL = `https://yeswevibe.com/${permalinkString}`;          
              console.log('finalURL if', finalURL);            
              location.href = finalURL;            
            }else{
              // console.log('/checkout');   
              // location.href = '/checkout';
              if( (directCheckout && addFreeStickers) || (directCheckout && addFreeGift) ){
                permalinkString += SS_permalink_if_no_free_gift_in_cart;
                let finalURL = `https://yeswevibe.com/${permalinkString}`;          
                console.log('finalURL SS + Sticker + Gift', finalURL);                          
                location.href = finalURL; 
              }else{              
                console.log('/checkout');   
                location.href = '/checkout';
              }
            }
            
          });        
        }else{        
          fetch('/cart.js')
          .then(res => res.json())
          .then(data => {
            // // //console.log('cart data: ', data);
  
            let cartItems = data.items;
            let permalinkString = '/cart/';
            
            let addFreeStickers = true;
            let addFreeGift = true;
            
            cartItems.forEach(function(itemEle){
              let prod_title = itemEle.title;
              let prod_variant_id = itemEle.id;
              let prod_qty = itemEle.quantity;
              
              // if(prod_title.includes('Safeguard')){
              //   addSafeguard = false;
              //   console.log('addSafeguard 11', addSafeguard);
              // }else{
              // // if(!prod_title.includes('Safeguard')){
              //   permalinkString += `${prod_variant_id}:${prod_qty},`;
              // }
              
              if(prod_title.includes('Safeguard')){
                // console.log('addSafeguard false true: ', addSafeguard);
                
              }else if( prod_variant_id == freeStickersID){//for freestickers
                addFreeStickers = false;
                console.log('addFreeStickers 2', addFreeStickers);
                permalinkString += `${prod_variant_id}:${prod_qty},`;   
                
              }else if( prod_variant_id == freeGiftID){//for freegift
                addFreeGift = false;
                console.log('addFreeGift 2', addFreeGift);
                permalinkString += `${prod_variant_id}:${prod_qty},`;   
                
              }else{  
                
                permalinkString += `${prod_variant_id}:${prod_qty},`;
              }
              
            });
            
            

            if(addFreeStickers && freeStickersID != null){            
              console.log('freeStickersID 22', freeStickersID);
              permalinkString += `${freeStickersID}:1,`;
            }

            if(addFreeGift && freeGiftID != null){            
              console.log('freeGiftID 22', freeGiftID);
              permalinkString += `${freeGiftID}:1,`;
            }
            
            let finalURL = `https://yeswevibe.com/${permalinkString}`;          
            console.log('finalURL else', finalURL);
  
            location.href = finalURL;
          });
        }
        
      });
  
    }
  
    // }, 1500);
    // custom safegaurd script ends
    
}
// custom safegaurd script ends



function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  async onInputChange(event) {
    this.validateQtyRules();

    // Check if the cart contains only a gift card
    const hasOnlyGiftCard = await cartHasOnlyGiftCardGlobal();
    console.log('hasOnlyGiftCard in input change:', hasOnlyGiftCard);
    if (!hasOnlyGiftCard) {
      // custom safegaurd script start
      setTimeout(() => {
       customSafegaurd();
      }, 1500);
    // custom safegaurd script ends
    }
    
  }

  async onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }

    // Check if the cart contains only a gift card
    const hasOnlyGiftCard = await cartHasOnlyGiftCardGlobal();
    console.log('hasOnlyGiftCard In Global BTN Change:', hasOnlyGiftCard);
    if (!hasOnlyGiftCard) {
      // custom safegaurd script start
      setTimeout(() => {
        customSafegaurd();
      }, 1500);
      // custom safegaurd script ends
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      // buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
      if(parseInt(value) <= parseInt(this.input.min)){
        let itemRemoveBtn = this.parentElement.nextElementSibling;
        // console.log('itemRemoveBtn', itemRemoveBtn);
        itemRemoveBtn.click();
      }
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));

    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) => {
      button.addEventListener('click', this.onCloseButtonClick.bind(this));
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        
        // Add the menu-drawer-open class to body when submenu is opened
        document.body.classList.add('menu-drawer-open');
        
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    
    // Add menu-drawer-open class to body when main menu is opened
    document.body.classList.add('menu-drawer-open');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    
    // Remove menu-drawer-open class from body only when the entire drawer is closed
    document.body.classList.remove('menu-drawer-open');
    
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
    
    // Keep the menu-drawer-open class on body even when returning to main menu
    // The class will only be removed when the entire drawer is closed
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer() {
    this.header = this.header || document.querySelector('.section-header');
    
    // Save current scroll position
    this.scrollPosition = window.scrollY || document.documentElement.scrollTop;
    
    document.documentElement.classList.add('js-drawer-open');
    document.body.classList.add('menu-drawer-open');
    
    // Maintain scroll position when fixing the body
    document.body.style.top = `-${this.scrollPosition}px`;
    
    if (this.header) this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.setAttribute('open', true);
      this.mainDetailsToggle.classList.add('menu-opening');
    }, 0);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    
    // Restore scroll position
    document.body.style.removeProperty('top');
    window.scrollTo(0, this.scrollPosition);
    
    document.querySelector('body').removeAttribute('style');
    document.querySelector('html').removeAttribute('style');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}


// BOF PRODUCT INTEREST MOBILE
const sideInterest = document.getElementById('navinterest');
const sideProduct = document.getElementById('navproducts');
const sideProductCollection = document.getElementById('mainsideprodcollection');
const sideInterestList = document.getElementById('maininterestwrap');

if(sideInterest){
  sideInterest.addEventListener('click', function() {
    let mainreapter = document.querySelector('.mainrepeaterwrap');

    sideProductCollection.classList.add("sidehidden");
    sideInterestList.classList.remove("sidehidden")
    
    if (sideInterest.classList.contains('active')) {
      sideInterest.classList.remove("active");
      mainreapter.classList.remove("active");
    } else {
      sideInterest.classList.add("active");
      mainreapter.classList.add("active");
    }
  });
}

if(sideProduct){
  sideProduct.addEventListener('click', function() {
    let mainreapter = document.querySelector('.mainrepeaterwrap');
    
    sideInterestList.classList.add("sidehidden");
    sideProductCollection.classList.remove("sidehidden");

    sideProductCollection
    if (sideProduct.classList.contains('active')) {
      sideProduct.classList.remove("active");
      mainreapter.classList.remove("active");
    } else {
      sideProduct.classList.add("active");
      mainreapter.classList.add("active");
    }
  });
}
// EOF PRODUCT INTEREST MOBILE

// BOF PRODUCT INTEREST SET ACTIVE
const getCollectionUrl = window.location.pathname;
const getCollectionParamURL = getCollectionUrl.split("/");

const getSidetoplinkCattitle = document.querySelectorAll('.sidetoplinkcattitle');
if(getSidetoplinkCattitle) {
    getSidetoplinkCattitle.forEach( (element) => {
      element.addEventListener('click' , function(e) { 
          e.preventDefault();
          this.closest(".sidebarproditem").classList.toggle("active");
      })}
    );
}

if(getCollectionParamURL[1] == 'collections') {
  // SET ACTIVE FOR PRODUCT SIDEBAR
  if(getCollectionParamURL[2] != '') {
    const getSideCurrProductCollection = document.querySelector('.sidebarsubnav .active');
    if(getSideCurrProductCollection) {
      getSideCurrProductCollection.closest(".sidebarproditem").classList.add("active");
    }
    // else{
    //   document.querySelector('#mainsideprodcollection .sidebarproditem').classList.add('active');
    // }
  }

  // SET ACTIVE FOR INTEREST TAGS
  if(getCollectionParamURL[3]) {
    const getInterestLists = document.querySelectorAll('#maininterestwrap .repeater-block');

    getInterestLists.forEach( (interest) => {
      let attrInterest = interest.getAttribute('data-interest');
      console.log("check", getCollectionParamURL[3], attrInterest );
      if ( attrInterest.includes([getCollectionParamURL[3]]) ) {
        interest.classList.add("active");
      }
    });
  }
}
// EOF PRODUCT INTEREST SET ACTIVE